/**
 * Copy for the Wi-Fi credential sharing page.
 *
 * Every claim here is load-bearing: this page asks a household for their home
 * network password, so the reassurance has to be accurate or it is worse than
 * saying nothing. Three claims from the original draft were corrected because
 * the implementation does not support them:
 *
 *   - deletion is triggered manually by the setup team, not automatically
 *   - the password is stored in plain text, so no at-rest encryption is claimed
 *   - nothing here is a prototype any more, so the disclaimers are gone
 *
 * If the retention or storage behaviour changes, change this file with it.
 */

export const FAQS = [
  {
    question: "Why can't I use a guest network?",
    answer:
      "Guest networks normally keep connected devices separate. That is useful for visitors, but it prevents the two connectors from finding the Smart Climate hub on your home network. They need your main 2.4 GHz Wi-Fi network to work together.",
  },
  {
    question: "What can the connectors access on my network?",
    answer:
      "Each USR-W610 joins your Wi-Fi like another connected device. Its own local access point is used during setup; it is not a Wi-Fi network for your household. Like any connected device, it can exchange traffic with systems it can reach, but we configure it for one job: passing control data between your Wavin or Nilan system and the Smart Climate hub. It is not given your browser history, emails, photos or passwords for other services.",
  },
  {
    question: "Where is my Wi-Fi password stored?",
    answer:
      "It is sent over an encrypted connection and stored in our database. Only the Smart Climate setup team can retrieve it, and every time someone does, it is recorded. We delete it once we have confirmed both connectors are working. The connectors keep the network details in their own memory so they can reconnect when you plug them in at home.",
  },
  {
    question: "What if I change my Wi-Fi later?",
    answer:
      "The connectors will need the new network name or password before they can reconnect. Contact the Smart Climate team and we will help you reconfigure them.",
  },
];

export const SETUP_STEPS = [
  {
    label: "Join the connector's setup network",
    detail: "We open the USR-W610's local configuration page on our preparation bench.",
  },
  {
    label: "Add your home network",
    detail: "We choose Station mode, WPA2 security and enter the network details you share here.",
  },
  {
    label: "Configure its single job",
    detail: "One connector is prepared for Wavin floor heating; the other for Nilan ventilation.",
  },
  {
    label: "Test, pack and confirm",
    detail:
      "Once both connectors pass our checks we pack your kit, and the team deletes your stored password.",
  },
];

/** The three assurances under the form. Each one must be literally true. */
export const TRUST_POINTS = [
  "Encrypted transfer",
  "Used for 2 connectors",
  "Deleted once your setup is confirmed",
];
